var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-start"},[_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" Not Found ")]),_c('v-card',[_c('v-card-title',[_vm._v("The page you have requested does not exist")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }